import { useGT } from 'gt-react';
import type { FreightOptionRow } from '@erp/rpc';

type Gt = ReturnType<typeof useGT>;

export function termsKindLabel(
  gt: Gt,
  kind: FreightOptionRow['freightTermsKind'],
): string {
  switch (kind) {
    case 'prepaid':
      return gt('Prepaid', { context: 'freight terms: vendor pays freight' });
    case 'prepaid_and_charge':
      return gt('Prepaid & charged', {
        context: 'freight terms: vendor ships and bills the freight back',
      });
    case 'collect':
      return gt('Collect', { context: 'freight terms: buyer pays freight' });
    case 'other':
      return gt('Other', { context: 'freight terms: any other arrangement' });
    default:
      return '';
  }
}

export function sourceLabel(gt: Gt, source: FreightOptionRow['source']) {
  switch (source) {
    case 'branch_default':
      return gt('ERP default', {
        context: 'freight option source: the branch default from the ERP',
      });
    case 'observed_release':
      return gt('Past releases', {
        context: 'freight option source: learned from past purchase orders',
      });
    case 'manual':
      return gt('Added by hand', {
        context: 'freight option source: entered by a person',
      });
  }
}

export function statusLabel(gt: Gt, status: FreightOptionRow['status']) {
  switch (status) {
    case 'confirmed':
      return gt('Confirmed', { context: 'freight option status' });
    case 'suggested':
      return gt('Suggested', {
        context: 'freight option status: waiting for a person to confirm',
      });
    case 'archived':
      return gt('Archived', { context: 'freight option status' });
  }
}
